export function parseSessionNotes(notes?: string): { foco: string; evidencia: string } {
  const text = notes?.trim() ?? '';
  if (!text) return { foco: '', evidencia: '' };

  const focoMatch = text.match(/^Foco:\s*([\s\S]*?)(?:\n\nEvidencia:|$)/i);
  const evidenciaMatch = text.match(/Evidencia:\s*([\s\S]*)$/i);

  if (focoMatch || evidenciaMatch) {
    return {
      foco: focoMatch?.[1]?.trim() ?? '',
      evidencia: evidenciaMatch?.[1]?.trim() ?? '',
    };
  }

  return { foco: text, evidencia: '' };
}

export function formatSessionNotes(foco: string, evidencia: string): string | undefined {
  const trimmedFoco = foco.trim();
  const trimmedEvidencia = evidencia.trim();

  if (trimmedFoco && trimmedEvidencia) {
    return `Foco: ${trimmedFoco}\n\nEvidencia: ${trimmedEvidencia}`;
  }
  if (trimmedFoco) return trimmedFoco;
  if (trimmedEvidencia) return `Evidencia: ${trimmedEvidencia}`;
  return undefined;
}
